module.exports = __webpack_public_path__ + "static/media/seal.699fc70e.svg";